export type MfaMethod = "totp" | "emailOtp" | "passkey";

export const MFA_METHOD_ORDER: MfaMethod[] = ["totp", "passkey", "emailOtp"];

export type LoginMfaChallenge = {
  otpRequired?: boolean;
  exchangeToken?: string;
  availableMethods?: MfaMethod[];
  selectedMethod?: MfaMethod;
  codeSent?: boolean;
  userHasRecoveryCodes?: boolean;
  passkeyOptions?: Record<string, unknown>;
};

export const isLoginMfaRequired = (
  data: unknown,
): data is LoginMfaChallenge => {
  return (
    typeof data === "object" &&
    data !== null &&
    "otpRequired" in data &&
    (data as LoginMfaChallenge).otpRequired === true
  );
};

const isPasskeyCancelled = (err: unknown) => {
  if (!err || typeof err !== "object") return false;
  const name = "name" in err && typeof err.name === "string" ? err.name : "";
  const message =
    "message" in err && typeof err.message === "string" ? err.message : "";

  return (
    name === "NotAllowedError" ||
    name === "AbortError" ||
    message.includes("timed out or was not allowed") ||
    message.includes("The request is not allowed") ||
    message.includes("operation was cancelled") ||
    message.includes("Operation was cancelled") ||
    message.includes("user denied") ||
    message.includes("User cancelled")
  );
};

/** Returns null when the user cancelled the passkey prompt. */
export const getPasskeyUserMessage = (
  err: unknown,
  t: (key: string) => string,
): string | null => {
  if (isPasskeyCancelled(err)) {
    return null;
  }
  const message =
    err &&
    typeof err === "object" &&
    "message" in err &&
    typeof err.message === "string"
      ? err.message
      : "";
  if (message === "PASSKEY_UNAVAILABLE") {
    return t("entry.mfa.passkeyUnavailable");
  }
  return t("entry.mfa.passkeyFailed");
};
